import React, { lazy } from 'react';
import CollapsedSidebarLayout from 'src/layouts/CollapsedSidebarLayout';
import Loader from 'src/components/Loader';

const ProviderOffers = Loader(lazy(() => import('../content/provider-offers')));

const ProviderOffersRoutes = [
	{
		path: 'provider-offers',
		element: <CollapsedSidebarLayout />,
		children: [
			{
				path: '',
				element: <ProviderOffers />,
			},
		],
	},
];

export default ProviderOffersRoutes;
